import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["currency"]

  pick(event) {
    if (event.currentTarget.value === "pensionfund" && this.hasCurrencyTarget) this.currencyTarget.value = "EUR"
  }
}
